import { useAction } from '@reatom/npm-react'
import { useEffect } from 'react'
import { css } from 'styled-components'
import { useMemo } from 'use-memo-one'

import { AppDataTable } from '@root/features/app-data-table/app-data-table'
import { reatomTradesTable } from '@root/features/trade/tables/trades-table/atoms'
import { getTradeTableRowStyle } from '@root/features/trade/tables/trades-table/ui/trades-table-util'

import type { ProfileWallet } from '@root/entities/profile/model'

type ProfileTradesTableProps = {
  wallets: ReadonlyArray<ProfileWallet.ProfileWallet>
}

export const ProfileTradesTable: React.FC<ProfileTradesTableProps> = ({
  wallets,
}) => {
  const walletAddresses = useMemo(() => {
    return wallets.map((wallet) => wallet.address)
  }, [wallets])

  const model = useMemo(
    () =>
      // eslint-disable-next-line @reatom/unit-naming-rule
      reatomTradesTable({
        pairAddress: undefined,
        pair: undefined,
        wallets: walletAddresses,
      }),
    [walletAddresses],
  )

  const initialize = useAction(model.initialize)

  useEffect(() => {
    return initialize()
  })

  return (
    <AppDataTable
      css={css`
        height: 100%;
      `}
      model={model}
      rowHeight={40}
      getRowStyle={getTradeTableRowStyle}
    />
  )
}
